import { render, staticRenderFns } from "./wl-image.vue?vue&type=template&id=f039cf4c&scoped=true&lang=pug"
import script from "./wl-image.js?vue&type=script&lang=js&external"
export * from "./wl-image.js?vue&type=script&lang=js&external"
import style0 from "./wl-image.styl?vue&type=style&index=0&id=f039cf4c&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f039cf4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f039cf4c')) {
      api.createRecord('f039cf4c', component.options)
    } else {
      api.reload('f039cf4c', component.options)
    }
    module.hot.accept("./wl-image.vue?vue&type=template&id=f039cf4c&scoped=true&lang=pug", function () {
      api.rerender('f039cf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-image/wl-image.vue"
export default component.exports